/**
 * Collection Notify Button Handler
 * This script handles Notify Me buttons on collection pages by using the existing
 * initVar and growConfig functions from the main notification system.
 */

// Function to ensure the notification modal exists
function ensureNotificationModal() {
  const modalId = 'gw-stock-fulfilled-iframe';
  let modal = document.getElementById(modalId);

  if (!modal) {
    console.log('Creating notification modal...');

    // Create the modal element directly in the DOM
    modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'gw-modal fade-in';
    modal.style.cssText = `
      position: fixed;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 99999;
      display: none;
      background: rgba(0, 0, 0, 0.65);
      align-items: center;
      justify-content: center;
    `;

    // Create modal content
    modal.innerHTML = `
      <div class="modal" role="dialog" aria-modal="true" style="
        background: white; 
        border-radius: 8px; 
        padding: 0; 
        max-width: 500px; 
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 4px 20px rgba(0,0,0,0.3);
        position: relative;
      ">
        <div class="modal-container" tabindex="0" style="padding: 20px;">
          <button type="button" class="close-icon" style="
            position: absolute;
            top: 10px;
            right: 15px;
            background: none;
            border: none;
            font-size: 24px; 
            font-weight: bold;
            cursor: pointer;
            color: #666;
            z-index: 10;
          ">×</button>
          <h3 class="modal-title" style="
            font-size: 18px; 
            font-weight: bold; 
            margin: 0 0 10px 0;
            color: #333;
          ">NOTIFY ME WHEN AVAILABLE</h3>
          <p class="notification-message" style="
            margin-bottom: 20px; 
            color: #666;
            font-size: 14px;
          ">We will notify you when a spot becomes available</p>
          
          <div class="success-message" id="success-message" style="
            background-color: #d4edda;
            color: #155724;
            padding: 10px;
            border-radius: 4px;
            margin-bottom: 15px;
            display: none;
          ">
            Your notification has been registered.
          </div>
          <div class="error-message" id="error-message" style="
            background-color: #f8d7da;
            color: #721c24;
            padding: 10px;
            border-radius: 4px;
            margin-bottom: 15px;
            display: none;
          ">
            Please enter a valid email address.
          </div>
          
          <input type="email" class="email-input" placeholder="Email Address" id="notify-email" style="
            width: 100%; 
            box-sizing: border-box;
            padding: 12px; 
            margin-bottom: 15px; 
            border: 1px solid #ddd; 
            border-radius: 4px;
            font-size: 14px;
          ">
          <button class="notify-button" style="
            background-color: #2059B6; 
            color: white; 
            padding: 12px 24px; 
            border: none; 
            border-radius: 4px; 
            cursor: pointer;
            width: 100%;
            font-size: 14px;
            font-weight: bold;
          ">Notify Me</button>
        </div>
      </div>
    `;

    // Add event listeners
    const closeButton = modal.querySelector('.close-icon');
    const notifyButton = modal.querySelector('.notify-button');
    const emailInput = modal.querySelector('.email-input');

    closeButton.addEventListener('click', () => {
      window.closeNotificationModal();
    });

    notifyButton.addEventListener('click', () => {
      window.submitNotification();
    });

    emailInput.addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        window.submitNotification();
      }
    });

    // Handle outside click to close
    modal.addEventListener('click', e => {
      if (e.target === modal) {
        window.closeNotificationModal();
      }
    });

    // Add to document
    document.body.appendChild(modal);
    console.log('Notification modal created');
  }

  return modal;
}

document.addEventListener('DOMContentLoaded', function () {
  // Store the currently active button data
  let activeButtonData = null;

  // First, attach basic click handlers immediately
  attachBasicClickHandlers();

  // Wait for the main notification system to load
  const waitForNotificationSystem = () => {
    // Check for both initVar and growConfig, and ensure stockWidgetClicked function exists
    if (
      window.initVar &&
      window.growConfig &&
      window.growConfig.stockWidgetClicked
    ) {
      initializeCollectionNotifyButtons();
    } else {
      console.log('Waiting for notification system to load...');
      setTimeout(waitForNotificationSystem, 200);
    }
  };

  // Attach basic click handlers that will work even if main system isn't loaded yet
  function attachBasicClickHandlers() {
    console.log('Attaching basic click handlers...');

    const notifyButtons = document.querySelectorAll(
      'button[gw-stock-fulfilled]'
    );

    notifyButtons.forEach(button => {
      // Skip if already has our event listener
      if (button.hasAttribute('data-basic-handler-attached')) {
        return;
      }

      // Mark as having basic handler
      button.setAttribute('data-basic-handler-attached', 'true');

      // Add click event listener
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        console.log('Notify button clicked (basic handler)', {
          productId: button.getAttribute('data-product-id'),
          variantId: button.getAttribute('data-variant-id'),
          productHandle: button.getAttribute('data-product-handle')
        });

        // Store the active button data for use in submission
        activeButtonData = {
          productId: button.getAttribute('data-product-id'),
          variantId: button.getAttribute('data-variant-id'),
          productHandle: button.getAttribute('data-product-handle')
        };
        window.activeButtonData = activeButtonData;

        // Set the initVar properties that the main system expects
        if (window.initVar) {
          window.initVar.clickedProductId = parseInt(
            button.getAttribute('data-product-id')
          );
          window.initVar.clickedProductHandle = button.getAttribute(
            'data-product-handle'
          );
          window.initVar.clickedVariantId = parseInt(
            button.getAttribute('data-variant-id')
          );
          console.log('Set initVar properties for collection notify:', {
            clickedProductId: window.initVar.clickedProductId,
            clickedProductHandle: window.initVar.clickedProductHandle,
            clickedVariantId: window.initVar.clickedVariantId
          });
        }

        // Try to use the main system if available
        if (
          window.growConfig &&
          typeof window.growConfig.stockWidgetClicked === 'function'
        ) {
          try {
            // Ensure the notification modal exists before calling the main system
            ensureNotificationModal();
            // Show our modal instead of relying on the main system
            window.showNotificationModal();
            return;
          } catch (error) {
            console.error('Error calling stockWidgetClicked:', error);
          }
        }

        // Fallback: Show our modal directly
        console.log('Main notification system not available, using fallback');
        ensureNotificationModal();
        window.showNotificationModal();
      });
    });

    console.log(
      `Attached basic handlers to ${notifyButtons.length} notify buttons`
    );
  }

  const initializeCollectionNotifyButtons = () => {
    console.log('Initializing collection notify buttons with main system...');

    // Find all notify buttons on the page
    const notifyButtons = document.querySelectorAll(
      'button[gw-stock-fulfilled]'
    );

    notifyButtons.forEach(button => {
      // Skip if already has our main system event listener
      if (button.hasAttribute('data-notify-initialized')) {
        return;
      }

      // Mark as initialized with main system
      button.setAttribute('data-notify-initialized', 'true');

      // Remove the basic handler and add the main system handler
      if (button.hasAttribute('data-basic-handler-attached')) {
        // Clone the button to remove all event listeners
        const newButton = button.cloneNode(true);
        newButton.removeAttribute('data-basic-handler-attached');
        newButton.setAttribute('data-notify-initialized', 'true');

        // Replace the old button with the new one
        button.parentNode.replaceChild(newButton, button);

        // Add the main system click handler to the new button
        newButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          console.log('Notify button clicked (main system handler)', {
            productId: newButton.getAttribute('data-product-id'),
            variantId: newButton.getAttribute('data-variant-id'),
            productHandle: newButton.getAttribute('data-product-handle')
          });

          // Store the active button data for use in submission
          activeButtonData = {
            productId: newButton.getAttribute('data-product-id'),
            variantId: newButton.getAttribute('data-variant-id'),
            productHandle: newButton.getAttribute('data-product-handle')
          };
          window.activeButtonData = activeButtonData;

          // Set the initVar properties that the main system expects
          if (window.initVar) {
            window.initVar.clickedProductId = parseInt(
              newButton.getAttribute('data-product-id')
            );
            window.initVar.clickedProductHandle = newButton.getAttribute(
              'data-product-handle'
            );
            window.initVar.clickedVariantId = parseInt(
              newButton.getAttribute('data-variant-id')
            );
            console.log(
              'Set initVar properties for collection notify (main system):',
              {
                clickedProductId: window.initVar.clickedProductId,
                clickedProductHandle: window.initVar.clickedProductHandle,
                clickedVariantId: window.initVar.clickedVariantId
              }
            );
          }

          // Use the existing growConfig.stockWidgetClicked function
          if (
            window.growConfig &&
            typeof window.growConfig.stockWidgetClicked === 'function'
          ) {
            try {
              // Ensure the notification modal exists before calling the main system
              ensureNotificationModal();
              // Show our modal instead of relying on the main system
              window.showNotificationModal();
            } catch (error) {
              console.error('Error calling stockWidgetClicked:', error);
            }
          } else {
            console.error('growConfig.stockWidgetClicked not available', {
              growConfig: !!window.growConfig,
              stockWidgetClicked: !!window.growConfig?.stockWidgetClicked,
              type: typeof window.growConfig?.stockWidgetClicked
            });
          }
        });
      }
    });

    console.log(
      `Initialized ${notifyButtons.length} notify buttons with main system`
    );
  };

  // Initialize immediately
  waitForNotificationSystem();

  // Also try to initialize after a delay as a fallback
  setTimeout(() => {
    if (
      !document.querySelector(
        'button[gw-stock-fulfilled][data-notify-initialized]'
      )
    ) {
      console.log('Fallback initialization attempt...');
      initializeCollectionNotifyButtons();
    }
  }, 2000);

  // Also try basic handlers as a fallback
  setTimeout(() => {
    if (
      !document.querySelector(
        'button[gw-stock-fulfilled][data-basic-handler-attached]'
      )
    ) {
      console.log('Fallback basic handler attempt...');
      attachBasicClickHandlers();
    }
  }, 1000);

  // Also initialize when new content is loaded (for infinite scroll, etc.)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any new notify buttons were added
        let hasNewButtons = false;
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Element node
            if (node.matches && node.matches('button[gw-stock-fulfilled]')) {
              hasNewButtons = true;
            } else if (
              node.querySelector &&
              node.querySelector('button[gw-stock-fulfilled]')
            ) {
              hasNewButtons = true;
            }
          }
        });

        if (hasNewButtons) {
          setTimeout(() => {
            attachBasicClickHandlers();
            initializeCollectionNotifyButtons();
          }, 100);
        }
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Global functions for the notification modal
window.closeNotificationModal = function () {
  const modal = document.getElementById('gw-stock-fulfilled-iframe');
  if (modal) {
    modal.style.display = 'none';
  }
};

window.showNotificationModal = function () {
  const modal = document.getElementById('gw-stock-fulfilled-iframe');
  if (modal) {
    modal.style.display = 'flex';
    // Focus on email input when modal opens
    const emailInput = modal.querySelector('#notify-email');
    if (emailInput) {
      setTimeout(() => emailInput.focus(), 100);
    }
  }
};

window.submitNotification = function () {
  const modal = document.getElementById('gw-stock-fulfilled-iframe');
  if (!modal) return;

  const emailInput = modal.querySelector('#notify-email');
  const email = emailInput ? emailInput.value.trim() : '';

  if (!email) {
    // Show error message
    const errorMsg = modal.querySelector('#error-message');
    if (errorMsg) {
      errorMsg.style.display = 'block';
    }
    return;
  }

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    const errorMsg = modal.querySelector('#error-message');
    if (errorMsg) {
      errorMsg.style.display = 'block';
    }
    return;
  }

  // Hide error message if it was showing
  const errorMsg = modal.querySelector('#error-message');
  if (errorMsg) {
    errorMsg.style.display = 'none';
  }

  // Try to use the main notification system if available
  if (
    window.initVar &&
    window.initVar.campaignPopUpNotifyButtonClicked &&
    window.activeButtonData
  ) {
    try {
      // Call the main notification system with the stored button data
      window.initVar.campaignPopUpNotifyButtonClicked(
        'gw-stock-fulfilled-iframe',
        window.initVar.stockFulFilledEmailCampaign.uniqueId,
        email,
        false // optInToMarketing
      );

      console.log('Notification submitted via main system:', {
        email: email,
        productId: window.activeButtonData.productId,
        variantId: window.activeButtonData.variantId,
        productHandle: window.activeButtonData.productHandle
      });
    } catch (error) {
      console.error('Error submitting notification via main system:', error);
    }
  } else {
    console.log('Main notification system not available, using fallback');
    console.log('Active button data:', window.activeButtonData);
  }

  // Show success message
  const successMsg = modal.querySelector('#success-message');
  if (successMsg) {
    successMsg.style.display = 'block';
  }

  // Close modal after a short delay
  setTimeout(() => {
    window.closeNotificationModal();
  }, 1500);
};

// Fallback function to manually trigger notify modal
window.triggerNotifyModal = function (productId, variantId, productHandle) {
  if (window.initVar && window.growConfig) {
    // Create a temporary event object
    const mockEvent = {
      target: {
        attributes: {
          'data-product-id': { value: productId },
          'data-variant-id': { value: variantId },
          'data-product-handle': { value: productHandle }
        }
      }
    };

    // Ensure modal exists before calling
    const modal = document.getElementById('gw-stock-fulfilled-iframe');
    if (!modal) {
      ensureNotificationModal();
    }

    window.growConfig.stockWidgetClicked(mockEvent);
  } else {
    console.error('Notification system not available');
  }
};
